/**
 * Count unique players who played a room (history/list cards).
 * Prefer listed players; fall back to game_ended leaderboards when the snapshot
 * players array was cleared after disconnects.
 */
export function countPlayersWhoPlayed(room: {
  players: Array<{ name?: string; id?: string }>;
  gameHistory?: Array<{
    type: string;
    leaderboard?: Array<{ playerName?: string; playerId?: string }>;
  }>;
}): number {
  const names = new Set<string>();

  for (const player of room.players) {
    const name = player.name?.trim().toUpperCase();
    if (name) names.add(name);
    else if (player.id) names.add(`id:${player.id}`);
  }

  if (names.size > 0) return names.size;

  for (const event of room.gameHistory || []) {
    if (event.type !== 'game_ended' || !event.leaderboard) continue;
    for (const entry of event.leaderboard) {
      const name = entry.playerName?.trim().toUpperCase();
      if (name) names.add(name);
      else if (entry.playerId) names.add(`id:${entry.playerId}`);
    }
  }

  return names.size;
}
